import { showToast } from "../ui/toastBus.ts";

export type TopologyOpFailureId =
  | "delete_vertices"
  | "delete_edges"
  | "delete_faces"
  | "delete_only_edges_and_faces"
  | "delete_only_faces"
  | "dissolve_vertices"
  | "dissolve_edges"
  | "dissolve_faces"
  | "subdivide"
  | "bridge_vertices"
  | "merge_by_distance"
  | "fill"
  | "bridge_edge_loops"
  | "grid_fill"
  | "connect_vertex_path"
  | "separate"
  | "rip"
  | "extrude"
  | "inset"
  | "bevel"
  | "edge_loop_insert"
  | "smooth";

export function notifyTopologyOpFailure(
  op: TopologyOpFailureId,
  reason: string,
): void {
  showToast(reason, { severity: "warning", dedupKey: `topology-op-${op}` });
}
